import { createApp } from 'vue'
import EarthquakeComparator from './EarthquakeComparator.vue'
import './assets/global.css'

createApp(EarthquakeComparator).mount('#earthquake')
